import { sanitizeSubdomainXSS } from '../../utils/sanitize'

// Decides the status of the day given the statuses of all the incidents on that day
const decideDayStatus = incidentsForDay => {
  // Return immediately if there are no incidents on this day
  const incidentsExistForDay = incidentsForDay.length > 0
  if (!incidentsExistForDay) {
    return "normal"
  }

  return incidentsForDay.some(incident => incident.attributes.outage) ? "outage" : "degradation"
}

const getQueryVariable = variable => {
  const query = window.location.search.substring(1)
  const vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')

    if (decodeURIComponent(pair[0]) === variable) {
      return sanitizeSubdomainXSS(decodeURIComponent(pair[1]))
    }
  }
  return null
}

export { decideDayStatus, getQueryVariable }
